import { HttpInterceptorFn } from '@angular/common/http'

export const bodyInterceptor: HttpInterceptorFn = (req, next) => {
	if (req.body) {
		const body = JSON.stringify(req.body)

		return next(req.clone({ body }))
	}

	return next(req)
}
